import { createAsyncThunk } from '@reduxjs/toolkit'

import * as api from 'connections/restApi'

export const get = createAsyncThunk('dashboardSummary/get', async () => {
  const response = await api.getDashboardSummary()
  return response
})
